import { InstanceMetadata } from "@opstel/query/models/instanceMetadata";
import { DataTable, DataTableColumnDef } from "@shared/EDS/components/DataTable/DataTable";
import { DATETIME_FORMAT_NO_SECONDS } from "@shared/common/utils/luxonHelpers";
import { useCurrentInstanceId } from "@shared/common/contexts/instanceMetadata/useInstanceId";
import { useCallback } from "react";

export interface ImportedPlansOverviewProps {
  readonly instances: InstanceMetadata[];
  readonly isLoading?: boolean;
  readonly closeDialog: () => void;
}

const columns: DataTableColumnDef<InstanceMetadata>[] = [
  {
    id: "scenarioStart",
    header: "Scenario",
    accessorKey: "scenarioStart",
    cell: ({ row }) =>
      `${row.original.scenarioStart.toFormat(DATETIME_FORMAT_NO_SECONDS)} t/m ${row.original.scenarioEnd.toFormat(DATETIME_FORMAT_NO_SECONDS)}`,
  },
  {
    id: "location",
    header: "Knoop",
    accessorKey: "location",
  },
  {
    id: "instanceId",
    header: "Scenario-Id",
    accessorKey: "instanceId",
  },
  {
    id: "openButton",
    enableSorting: false,
    cell() {
      return (
        <div style={{ display: "flex", gap: "10px" }}>
          <div style={{ width: "25px", display: "flex", alignItems: "center" }}>
            <tractie-button level="tertiary" icon-only>
              <tractie-icon name="chevron-right" />
            </tractie-button>
          </div>
        </div>
      );
    },
  },
];

export function ImportedPlansOverview({
  instances,
  isLoading = false,
  closeDialog,
}: ImportedPlansOverviewProps) {
  const { setCurrentInstanceId } = useCurrentInstanceId();

  const openInstance = useCallback(
    (instanceId: string) => {
      console.log(`Opened instance with id: ${instanceId}`);
      setCurrentInstanceId(instanceId);
      closeDialog();
    },
    [setCurrentInstanceId, closeDialog],
  );

  return (
    <DataTable
      className="imported-plans-overview-table"
      columns={columns}
      data={instances}
      defaultSort={[{ id: "scenarioStart", desc: true }]}
      options={{
        rowClick: (row) => openInstance(row.original.instanceId),
        emptyMessage: "Er zijn geen geïmporteerde plannen beschikbaar.",
        loadingMessage: "Plannen worden geladen",
      }}
      isLoading={isLoading}
    />
  );
}
